import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";

import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerFilter } from "@/components/Store/StorePicker/types/storePickerFilter.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { StorePickerModalStates } from "@/utils/enums";

import { useECommerceContext } from "../../context/eCommerce.context";
import { useStorePickerModalContext } from "../../context/storePickerModal.context";
import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { useProductDetail } from "../../hooks/useProductDetail.hook";

const StorePickerInfoComponent = () => {
    const {
        storePickerType,
        storePickerModalState,
        setStorePickerModalState,
        storeCode
    } = useStorePickerModalContext();
    const { isEcommerceReady, infoLink } = useECommerceContext();
    const { isBoxArticle } = useECommerceProduct();
    const { deliveryType } = useProductDetail();
    const isOpen = storePickerModalState !== StorePickerModalStates.Closed;

    return (
        <>
            {isEcommerceReady &&
                storePickerType === StorePickerType.INFO &&
                isOpen && (
                    <StorePickerModal
                        isOpen={isOpen}
                        type={StorePickerType.INFO}
                        displayStockLevel={!isBoxArticle}
                        initialActiveFilters={[
                            StorePickerFilter.FILTER_EMPTY_STOCK
                        ]}
                        infoLink={infoLink}
                        storeCode={storeCode}
                        fixedFeatures={
                            deliveryType === DeliveryType.ClickAndCollect
                                ? [
                                      StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE
                                  ]
                                : []
                        }
                        onClose={() =>
                            setStorePickerModalState(
                                StorePickerModalStates.Closed
                            )
                        }
                    />
                )}
        </>
    );
};

export { StorePickerInfoComponent };
